import { DateTime } from "luxon";

export function maskPercent(paramNumber) {
    return new Intl.NumberFormat("pt-BR", {
      style: "percent",
      minimumFractionDigits: 2,
      // maximumFractionDigits: 2,
    }).format(paramNumber);
  }
  
  export function maskCurrency(paramNumber) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(paramNumber));
  }

  export function maskDate(date) {
    let formatedDate = date;
    if(!date?.includes('T')) {
      if(date?.includes(' '))
        formatedDate = date?.replace(' ','T');
    };
  
    return DateTime.fromISO(formatedDate).setLocale('pt-BR').toLocaleString(DateTime.DATE_SHORT);
  }

  export function maskDateTime(date) {
    let formatedDate = date;
    if(!date?.includes('T')) {
      if(date?.includes(' '))
        formatedDate = date?.replace(' ','T');
    };
  
    return DateTime.fromISO(formatedDate).setLocale('pt-BR').toLocaleString(DateTime.DATETIME_SHORT);
  }
  
  export const removeMask = (value) => (value.length > 0 ? value.replaceAll(/[^0-9]/g, "") : value);